import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class RV {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }


    pg_recv_vehicle_details(payload) {
        console.log('BL for pg_recv_vehicle_details: ', payload);
        const vehNo = this.ctx.getters.funnel.elements['in_veh_no'].value;
        this.fs.showTwinButtonCardLoader('vehicle', vehNo);
        return;
    }

    update(e, input, args) {
        const field = input.id.split('in_')[1];
        const veh = {};
        const vfields = [...this.ctx.getters.rvYmmb];

        for (const vf of vfields) {
            veh[vf] = this.ctx.getters.funnel.elements[`in_${vf}`].value;
        }
        this.rvDiscovery(field, veh);
        this.postUpdateProcesses(field, veh);
    }

    postUpdateProcesses(field, veh) {
        if (field == 'year') {
            this.resetRVLengthOwnedOptns(veh);
        }
    }

    rvDiscovery(field, veh) {
        var payload = this.createRVDiscoveryPayload(field, veh);

        if (Utils.isEmpty(veh[field])) {
            const ymmb = this.ctx.getters.rvYmmb;
            const rstFromIndx = ymmb.indexOf(field) + 1;
            const resetFields = ymmb.slice(rstFromIndx);

            for (const f of resetFields) {
                const uid = this.rvPropStr(f);
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'typed_option', val: '' });
                this.resetVehYmmbElems(uid);
            }
            this.resetVehsCashValue();
            return;
        }

        if (payload) {
            this.ctx.dispatch('processRVDiscovery', payload);
        }
    }

    resetRvFieldAndOptions(payload) {
        /* If current value is not in the returned array reset current value.
        For a vehicle, if a value is set for the requested resource and the value is contained in the
        resource result set (the options), there is no need to reset the value and options otherwise
        reset. */
        //const vehicle = new Vehicle({ ctx: context });
        var field = payload.req.rsrc;
        var options = payload.res;
        var iuid = this.rvPropStr(field);

        if (this.ctx.getters.rvYmmbCtrl.length > 0) {
            for (const vf of this.ctx.getters.rvYmmbCtrl) {
                const vfIuid = this.rvPropStr(vf);
                var rstNxtFVal = this.ctx.getters.funnel.elements[vfIuid].value;
                if (rstNxtFVal != '' && Array.isArray(options) && options.indexOf(rstNxtFVal) != -1 && vf == payload.req.rsrc) {
                    break;
                } else {
                    this.resetVehYmmbElems(vfIuid);
                }
            }
        }

        if (field != 'nada_id') {
            var optsObjs = options;
            if (!Utils.isObjEmpty(options) && typeof options[0] != 'object') {
                if (field == 'bodystyle') {
                    this.resetVehsCashValue();
                    optsObjs = Utils.buildSelectOptions(options, true, false, true);
                } else {
                    optsObjs = Utils.buildSelectOptions(options);
                }
            }
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: iuid, key: 'options', val: optsObjs }); /// Sets the options.
        }
    }

    createRVDiscoveryPayload(vfield, veh) { // vfield, vehNo, veh
        /* For the field that changed in YMMT waterfall collect values of the previous fields if any
        and build the request payload; also take note of subsequent fields to be reset if any.
        */
        console.log('Ymmb', this.ctx.getters.rvYmmb);
        var rscIndx = this.ctx.getters.rvYmmb.indexOf(vfield);
        var resource = this.ctx.getters.rvYmmb[rscIndx + 1];
        var pd = null;
        var params = {};
        this.ctx.commit('resetRvYmmbCtrl');
        console.log(`${vfield} for the veh changed get ${vfield == 'bodystyle' ? 'nada_id' : resource}`);

        params = this.buildReqParamsAndResetRvFields(rscIndx, veh);

        if (vfield == 'bodystyle') {
            params = {};
            resource = 'nada_id';
            params['ymmb_path'] = `${veh['year']}_${veh['make']}_${veh['model']}_bodystyles`;
        }

        if (!Utils.isEmpty(resource)) {
            pd = { rsrc: resource, fields: params, veh: veh };
            //pd = { vehNo: vehNo, rsrc: resource, fields: params, veh: veh };
        }
        console.log('RV discovery payload is:', pd);
        return pd;
    }

    buildReqParamsAndResetRvFields(rscIndx, veh) {
        var ctx = this.ctx;
        var params = {};
        var fields = [];
        fields = this.ctx.getters.rvYmmb.filter(function (vf, index) {
            if (index <= rscIndx) {
                return true;
            }
            ctx.commit('addRvYmmbCtrl', vf);
            return false;
        });

        for (const field of fields) {
            if (veh[field] != '') {
                params[field] = veh[field];
            } else {
                break;
            }
        }
        return params;
    }

    setRvDetail(vehDtlsElems) {
        console.log('setRvDetail: ', vehDtlsElems);
        for (const iuid in vehDtlsElems) {
            for (const prop of ['value', 'raw_value']) {
                const val = vehDtlsElems[iuid][prop];
                if (!Utils.isEmpty(val)) {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: iuid, key: prop, val: val });
                }
            }
        }
    }

    rvPropStr(vfield) {
        return `in_${vfield}`;
    }

    resetRVLengthOwnedOptns(veh) {
        const lenOwndOpts = this.buildLengthOwnedYears(veh['year']);
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_length_owned', key: 'options', val: lenOwndOpts });
    }

    buildLengthOwnedYears(vehYear = null) {
        const years = [{ label: '', value: '' }];
        const currYr = new Date().getFullYear();
        const lim = 9;
        const vehProdYr = vehYear ? parseInt(vehYear) - 1 : null;

        for (let i = 0; i <= lim; i++) {
            const yr = currYr - i;

            let v;
            if (i === 0) {
                v = 'Less than 1 year';
            } else if (i === lim) {
                v = `${yr} or Before`;
            } else {
                v = `${yr}`;
            }

            years.push({ label: v, value: i });

            if (vehProdYr === yr) {
                break;
            }
        }
        return years;
    }

    resetVehsCashValue() {
        for (const prop of ['value', 'raw_value']) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_actual_cash_value', key: prop, val: '' });
        }
    }

    resetVehYmmbElems(uid) {
        if (!Utils.isEmpty(this.ctx.getters.funnel.elements[uid].typed_option))
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'typed_option', val: '' });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'options', val: Utils.buildSelectOptions() });
    }

}
